import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgVeryDryGlyphSecondary from './svgs/VeryDryGlyphSecondary.js';
import SvgVeryDryGlyph from './svgs/VeryDryGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var veryDryGlyph = (props => useIcon(SvgVeryDryGlyph, SvgVeryDryGlyphSecondary, props));

export { veryDryGlyph as default };
